module.exports = __webpack_public_path__ + "assets/img/film-bj.4da4d30a.png";